module.exports = __webpack_public_path__ + "img/ico_xingjunlibao.cce884b3.png";